import { useState } from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import Button from "../ui/Button";
import { BsChevronLeft, BsChevronRight } from "react-icons/bs";

// Import Swiper and modules
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";

// Import Swiper styles
import "swiper/css";
import "swiper/css/autoplay";

const banners = [
  {
    id: 1,
    title: "Client Hair Care Journey",
    subtitle: "REAL RESULTS",
    description:
      "See how our products transform and nourish natural hair textures",
    video:
      "https://res.cloudinary.com/dmxzxo1fk/video/upload/v1742824407/client_using_2_uuthnp.mp4",
    duration: 15000, // Duration in milliseconds (adjust based on actual video length)
  },
  {
    id: 2,
    title: "Natural Hair Care Routine",
    subtitle: "CLIENT SHOWCASE",
    description:
      "Watch how our clients incorporate our products into their daily routines",
    video:
      "https://res.cloudinary.com/dmxzxo1fk/video/upload/v1742824530/c1_aw96j1.mp4",
    duration: 20000,
  },
  {
    id: 3,
    title: "Complete Product Range",
    subtitle: "PRODUCT SHOWCASE",
    description: "Discover our full range of natural hair care solutions",
    video:
      "https://res.cloudinary.com/dmxzxo1fk/video/upload/v1742823770/all_products_use_rn6rlu.mov",
    duration: 18000,
  },
  {
    id: 4,
    title: "Behind The Scenes",
    subtitle: "PRODUCT CREATION",
    description:
      "Witness the care and expertise that goes into creating our products",
    video:
      "https://res.cloudinary.com/dmxzxo1fk/video/upload/v1742824868/shamp_making_au4c7p.mov",
    duration: 25000,
  },
];

export default function BannerCarousel() {
  const [activeIndex, setActiveIndex] = useState(0);

  return (
    <div className="relative overflow-hidden">
      <div className="max-w-[1400px] mx-auto px-4 sm:px-6 lg:px-8">
        <div className="relative h-[500px] md:h-[600px] lg:h-[700px] mt-4 mb-4 rounded-2xl overflow-hidden">
          <Swiper
            modules={[Autoplay]}
            autoplay={{
              delay: banners[activeIndex]?.duration || 58000, // Use video duration
              disableOnInteraction: false,
            }}
            loop={true}
            className="h-full w-full rounded-2xl"
            onSlideChange={(swiper) => setActiveIndex(swiper.realIndex)}
          >
            {banners.map((banner) => (
              <SwiperSlide key={banner.id} className="relative h-full">
                {/* Gradient Overlay */}
                <div className="absolute inset-0 bg-gradient-to-r from-black/80 via-black/50 to-transparent z-10" />

                {/* Banner Video */}
                <video
                  key={banner.id}
                  autoPlay
                  muted
                  loop={false}
                  playsInline
                  className="absolute inset-0 w-full h-full object-cover bg-black"
                  onEnded={(e) => {
                    const swiperInstance =
                      document.querySelector(".swiper").swiper;
                    swiperInstance.slideNext();
                  }}
                >
                  <source src={banner.video} type="video/mp4" />
                  Your browser does not support the video tag.
                </video>

                {/* Content */}
                <div className="relative z-20 h-full flex flex-col justify-center px-8 md:px-16">
                  {/* Subtitle */}
                  <motion.span
                    initial={{ opacity: 0, y: -20 }}
                    animate={{ opacity: 1, y: 0 }}
                    className="inline-block px-4 py-1 mb-4 text-sm md:text-base font-bold tracking-wider text-[#C84E59] bg-white/10 backdrop-blur-sm rounded-full w-fit"
                  >
                    {banner.subtitle}
                  </motion.span>

                  <motion.h2
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    className="text-4xl md:text-6xl font-serif font-bold text-white mb-4 drop-shadow-lg"
                  >
                    {banner.title}
                  </motion.h2>

                  <motion.p
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ delay: 0.2 }}
                    className="text-xl md:text-2xl text-white/90 mb-8 max-w-xl drop-shadow-lg"
                  >
                    {banner.description}
                  </motion.p>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>
    </div>
  );
}

// Add this CSS to your global styles
const styles = `
.banner-carousel .slick-dots {
  bottom: 2rem;
  z-index: 40;
}

.banner-carousel .slick-dots li {
  margin: 0 0.5rem;
}

.banner-carousel .slick-slide > div {
  line-height: 0;
}
`;
